import { createSelector } from 'reselect'

export const root = state => state.get('googleAnalytics')
export const createIntegrationSelector = key => createSelector(root, root => root.getIn(['integration', key]))

export const settingsLoaded = createIntegrationSelector('settingsLoaded')
export const trackingName = createIntegrationSelector('trackingName')
export const individualEventsEnabled = createIntegrationSelector('individualEventsEnabled')
export const enabledEventMappingsSelector = createIntegrationSelector('enabledEventMappings')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/googleAnalytics/selectors.js